<template>
  <el-skeleton class="sk" animated>
    <template #template>
      <el-skeleton-item variant="image" class="sk__image" />
      <div class="sk__block">
        <el-skeleton-item variant="p" class="sk__name" />
        <el-skeleton-item variant="p" class="sk__price" />
        <div class="sk__bottom">
          <el-skeleton-item variant="p" class="sk__button" />
          <el-skeleton-item variant="p" class="sk__tag" />
        </div>
      </div>
    </template>
  </el-skeleton>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.sk {
  width: 275px;
  padding: 15px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.61);
  display: flex;
  flex-direction: column;
  gap: 10px;

  &__image {
    width: 100%;
    height: 322px;
    border-radius: 20px 20px 0 0;
  }

  &__block {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    &-inner {
      width: 50%;
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }

  &__name {
    width: 100%;
    height: 22px;
  }

  &__price {
    width: 50px;
    height: 22px;
  }

  &__bottom {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__button {
    width: 85px;
    height: 26px;
  }

  &__tag {
    width: 90px;
    height: 18px;
  }
}

:deep(.el-skeleton__item) {
  --el-skeleton-color: #c9ccd0 !important;
  --el-skeleton-to-color: #c3c3c7 !important;
}
</style>